import http from "../../utils/httpClient";

class searchSuggestionService {
  createOrUpdateSearchSuggestion = async (data) => {
    return await http
      .post("/api/v2/Search/AddOrEditSearchSuggestion", data)
  };

  getSearchSuggestions = async (query) => {
    return await http.get("/api/v2/Search/GetAllSearchSuggestions", { params: query });
  };

}
export default new searchSuggestionService();